import { Component } from "@angular/core";

@Component ({
    selector: 'initialization-component',
    templateUrl: 'initialization.component.html',
    standalone: false
})
export class InitializationComponent {
    
}